"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getEventQueue_1 = require("./getEventQueue");
var removeSpecialCharacters_1 = require("./removeSpecialCharacters");
function removeAllSpecialCharacters(obj) {
    for (var key in obj) {
        if (typeof obj[key] === "string" && key !== "targetURL") {
            obj[key] = (0, removeSpecialCharacters_1.default)(obj[key]);
        }
        else if (typeof obj[key] === "object" && obj[key] !== null) {
            removeAllSpecialCharacters(obj[key]);
        }
    }
}
var pushEvent = function (event) {
    var queue = (0, getEventQueue_1.default)();
    removeAllSpecialCharacters(event);
    queue.push(event);
};
exports.default = pushEvent;
